<template>
    <div v-if="payments && payments.length > 0" class="shipment-open-report-payments-display">
        <v-menu offset-y left>
            <template #activator="{ on, attrs }">
                <v-chip
                    small
                    color="primary"
                    outlined
                    class="shipment-open-report-payments-display__chip"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ payments.length }}
                    <v-icon small class="ml-1">mdi-receipt</v-icon>
                </v-chip>
            </template>
            <v-list dense class="shipment-open-report-payments-display__menu">
                <v-list-item
                    v-for="(payment, index) in payments"
                    :key="payment.id || index"
                    class="shipment-open-report-payments-display__item"
                >
                    <v-list-item-content>
                        <v-list-item-title
                            class="shipment-open-report-payments-display__amount"
                        >
                            {{ formatCurrency(payment.amount || 0) }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <div class="shipment-open-report-payments-display__details">
                                <span
                                    v-if="payment.source"
                                    class="shipment-open-report-payments-display__source"
                                >
                                    {{ payment.source }}
                                </span>
                                <v-chip
                                    small
                                    :color="payment.is_receipt ? 'success' : 'info'"
                                    text-color="white"
                                    class="shipment-open-report-payments-display__type-chip"
                                >
                                    {{
                                        payment.is_receipt
                                            ? $t('pages.report.openShipmentReport.receipt')
                                            : $t('pages.report.openShipmentReport.invoice')
                                    }}
                                </v-chip>
                                <DateCell
                                    v-if="payment.created_at"
                                    :value="payment.created_at"
                                    :utc="false"
                                    format-type="dd-MM-yyyy"
                                />
                            </div>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="payment.document_link">
                        <ShipmentDocumentLink
                            :link="payment.document_link"
                        />
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
    <span v-else>-</span>
</template>

<script>
import DateCell from '@/components/common/cells/date-cell.vue'
import ShipmentDocumentLink from '@/components/shipments/shipment-document-link.vue'

export default {
    name: 'ShipmentOpenReportPaymentsDisplay',
    components: {
        DateCell,
        ShipmentDocumentLink,
    },
    props: {
        payments: {
            type: Array,
            default: () => null,
        },
    },
    methods: {
        formatCurrency(price) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(price)
        },
    },
}
</script>

<style lang="scss" scoped>
.shipment-open-report-payments-display {
    display: flex;
    justify-content: center;

    &__chip {
        cursor: pointer;
    }

    &__menu {
        max-width: 300px;
        max-height: 400px;
        overflow-y: auto;
    }

    &__item {
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
            border-bottom: none;
        }
    }

    &__amount {
        font-weight: 600;
        font-size: 14px;
        color: #333;
    }

    &__details {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 4px;
        flex-wrap: wrap;
    }

    &__source {
        font-size: 12px;
        color: #666;
        padding: 2px 6px;
        background: #f5f5f5;
        border-radius: 4px;
    }

    &__type-chip {
        font-size: 10px;
        height: 18px;
    }
}
</style>

